import { TableCellFactory } from "../../../common/tables/factory";
import {
    CostPayoutModifierTableRow
} from "../../../../../common/tables/cost-payout-modifier/CostPayoutModifierTableRow";
import { CostPayoutModifier } from "../../../../../common/models";
import { EnumResolver } from "../../../common/tables/etc/EnumResolver";
import { CPMEnumMapper } from "../etc/CPMEnumMapper";

export class CPMTableCellFactory extends TableCellFactory<CostPayoutModifierTableRow, CostPayoutModifier> {
    readonly enumResolver: EnumResolver<CostPayoutModifierTableRow> = new CPMEnumMapper();
}
